import { getAllProducts, getSingleProduct } from "../Services/Https/products";
import { useQuery } from "react-query";
import { material } from "../Model/Product";
import { useMemo } from "react";
export const useAllProducts = (
  available_pink: boolean | null,
  available_white: boolean | null,
  available_yellow: boolean | null,
  order: string | null,
  orderBy: string | null,
  page: number,
  perPage: number,
  discount_flag: boolean | null,
  briliant: boolean | null,
  search: string | null,
  material: material | null,
  favorite_flag: boolean | null,
  category_key?: string,
  subcategory_key?: string,
) => {
  return useQuery(
    [
      "products",
      order,
      orderBy,
      page,
      perPage,
      discount_flag,
      briliant,
      category_key,
      subcategory_key,
      search,
      material,
      available_pink,
      available_white,
      available_yellow,
      favorite_flag,
    ],
    () =>
      getAllProducts(
        available_pink,
        available_white,
        available_yellow,
        order,
        orderBy,
        page,
        perPage,
        discount_flag,
        briliant,
        search,
        material,
        favorite_flag,
        category_key,
        subcategory_key,
      ),
    { keepPreviousData: true },
  );
};

export const useSingleProduct = (id: string) => {
  return useQuery(["product", id], () => getSingleProduct(id));
};

export const useSimilarProducts = ({
  id,
  material,
  category_id,
  subcategory_id,
}: {
  id?: string;
  material: material;
  category_id: string;
  subcategory_id: string;
}) => {
  const { data } = useQuery(
    ["similar-products", material, category_id, subcategory_id, id],
    () =>
      getAllProducts(
        null,
        null,
        null,
        "desc",
        "popular",
        1,
        20,
        null,
        null,
        null,
        material,
        null,
        category_id,
        subcategory_id,
      ),
  );

  const similarProducts = useMemo(() => {
    return data?.products
      ?.filter((product: { id: number }) => product.id !== Number(id))
      ?.sort(() => Math.random() - 0.5)
      ?.slice(0, 4);
  }, [data, id]);

  return similarProducts;
};
